export interface GroupDomain {
  uuid: string;
  name: string;
}

export interface GroupRole {
  code: string;
  name: string;
}

export interface Group {
  uuid: string;
  name: string;
  description?: string;
  domains: GroupDomain[];
  usersCount: number;
  /**
   * The list (`getAll`) endpoint returns `creator.full_name` (-> `fullName`),
   * while the single-group (`getOne`) endpoint returns `creator.user_full_name`
   * (-> `userFullName`). Both keys are modeled so the view drawer can read the
   * `getOne` shape and fall back to the list shape.
   */
  creator?: { fullName?: string; userFullName?: string } | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * A user row returned by `GET /groups/{uuid}/users` (after snake->camel).
 * The role is nested under `groupRole` in the response.
 */
export interface GroupUser {
  uuid: string;
  firstName?: string;
  lastName?: string;
  groupRole?: GroupRole;
}

/**
 * A member option returned by `GET /picklist/domains/{uuid}/users`
 * (the picklist payload is `{ list: [{ value, label }] }`).
 */
export interface GroupUserPicklistOption {
  value: string;
  label: string;
}

export interface GroupsListMeta {
  currentPage: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface GroupsListResponse {
  data: Group[];
  meta: GroupsListMeta;
}

export interface GroupSubmitPayload {
  uuid?: string;
  name: string;
  description?: string;
  domains: { uuid: string }[];
  users: { uuid: string; role_id: string }[];
  owner_uuid: string;
}

export const DEFAULT_GROUPS_CURRENT_PAGE = 1;
export const DEFAULT_GROUPS_PER_PAGE = 25;
export const GROUPS_PAGE_SIZE_OPTIONS = [DEFAULT_GROUPS_PER_PAGE, 50, 100] as const;
